import { DEFAULT_DATE } from '../utilities/constants';
import { getValueFromLocalStorage } from '../utilities/utilityFunctions';
import { client, gql } from './Client';

const workPackageListQuery = gql`
  query mobileWorkPackageFeed(
    $siteId: Int!
    $disciplineId: Int!
    $lastModified: DateTime!
    $isLeadInspector: Boolean!
  ) {
    mobileWorkPackageFeed(
      siteId: $siteId
      disciplineId: $disciplineId
      lastModified: $lastModified
      isLeadInspector: $isLeadInspector
    ) {
      workPackageId
      workPackageStatusId
      noOfInspections
    }
  }
`;

const workPackageList = (siteId: number, disciplineId: number) =>
  client.query({
    query: workPackageListQuery,
    variables: {
      siteId,
      disciplineId,
      lastModified: DEFAULT_DATE,
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  });

export { workPackageList };
